import { makeBlockMathInputRule, REGEX_BLOCK_MATH_DOLLARS } from '@benrbray/prosemirror-math';
import { NodeSpec } from 'prosemirror-model';

import { BaseExtension, EditorOptions } from '@lyearn/lygo-core';

import { getSchema, NODE_NAME } from './consts';
import plugins from './plugins';

export default class MathDisplay extends BaseExtension {
  get schema(): NodeSpec {
    return getSchema();
  }

  get name(): string {
    return NODE_NAME;
  }

  inputRules = ({ schema }: EditorOptions) => {
    return [makeBlockMathInputRule(REGEX_BLOCK_MATH_DOLLARS, schema.nodes.math_display)];
  };

  plugins = plugins;
}
